import { useApi } from '@/composables/use-api'
import type { WishTicketPostRequest } from './types'

export async function fetchWishApplications() {
  const { abaSupportAPI } = useApi()
  const { data } = await abaSupportAPI.wish.getApplications()
  return data
}

export async function postWishTicket(
  requestBody: WishTicketPostRequest,
  files?: File[],
) {
  const { abaSupportAPI } = useApi()
  const { data } = await abaSupportAPI.wish.submitTicket({
    data: JSON.stringify(requestBody),
    files,
  })
  return data
}
